import * as React from "react"

import { cn } from "../../lib/utils"

const alertStyles = {
  title: "font-medium [&_a:hover]:text-fg",
  description: "text-sm leading-sm text-muted-foreground text-balance [&_a:hover]:text-fg [&_p:not(:last-child)]:mb-4",
  action: "absolute right-2 top-2",
}

type AlertVariantProps = {
  variant?: "default" | "destructive"
}

function Alert({
  className,
  variant = "default",
  ...props
}: React.ComponentProps<"div"> & AlertVariantProps) {
  return (
    <div
      data-slot="alert"
      role="alert"
      className={cn(
        "relative grid w-full gap-0.5 rounded-lg border border-border bg-card px-2.5 py-2 text-left text-sm leading-sm",
        variant === "destructive" ? "text-destructive" : "text-card-foreground",
        className,
      )}
      {...props}
    />
  )
}

function AlertTitle({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="alert-title"
      className={cn(alertStyles.title, className)}
      {...props}
    />
  )
}

function AlertDescription({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="alert-description"
      className={cn(alertStyles.description, className)}
      {...props}
    />
  )
}

function AlertAction({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="alert-action"
      className={cn(alertStyles.action, className)}
      {...props}
    />
  )
}

export { Alert, AlertTitle, AlertDescription, AlertAction }
